<mat-toolbar>
    <mat-toolbar-row>
        <button mat-icon-button [matMenuTriggerFor]="menu" [disableRipple]="true"
                data-e2e="tralalere-bar-menu">
            <mat-icon svgIcon="trala_btn"></mat-icon>
        </button>
        <mat-menu #menu="matMenu" backdropClass="tralalere-bar" class="tralabar">
            <button mat-menu-item *ngFor="let link of links" (click)="goToSite(link.get('href'))" data-e2e="tralalere-go-to">
                <mat-icon *ngIf="displayTralabarIcons" >web_asset</mat-icon>
                <span>{{ link.get('label') | translate }}</span>
            </button>
        </mat-menu>
    </mat-toolbar-row>
</mat-toolbar>
